import { useState, useEffect } from 'react';

/**
 * Hook para implementar debounce en un valor.
 * Muy útil para retrasar la búsqueda al escribir en un input.
 * 
 * @param value Valor a aplicar debounce
 * @param delay Retraso en milisegundos (por defecto 300)
 * @returns El valor retrasado
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
